import StartupPricingImage from "../../../assets/images/pricing/startup.png" ;
import BusinessPricingImage from "../../../assets/images/pricing/business.png" ;
import CorporatePricingImage from "../../../assets/images/pricing/corporate.png" ;
import PricingCard from "../../common/pricing-cards/pricing-card";
import { startupPackinfo , businessPackInfo , corporatePackInfo } from "./pricingPlanInfo";
import { SIGNUP_ROUTE } from "../../../routes";

const PricingSection = (props) => {

    const handlePlanSelection = (plan) => {
        //console.log(plan)
        props.history.push(SIGNUP_ROUTE , { state: { plan } });
    }

    return (
        <section
            ref={props.anchor}
            id="pricing"
            style={{ backgroundColor: "#00252D" }}
        >
            <div className="container-md" style={{ padding: "8rem 0" }}>
                <h1 className="text-center text-primary px-4">
                    Pricing built for businesses of all sizes
                </h1>
                <p className="text-center text-inverse text-body-1 mt-5 px-4">
                    Now, becoming compliant and staying compliant has never been more affordable. Pricing starts from a low $110 per month (including GST) . Grow your business and unlock more aspects of 
                    iComply. Implement more assistance when you need it most. 

                </p>


                <div className="container-fluid">
                <div
                    className="row row-cols-1 row-cols-md-1 row-cols-lg-3"
                    style={{ marginTop: "0rem", "--bs-gutter-y": "6rem" }}
                >
                    {/* <div className="col-md d-flex justify-content-center">
                        <PricingCard
                            image={StartupPricingImage}
                            title="Start Up"
                            info="1 to 3 Users"
                            price="89"
                            bg="#60C3AD"
                            points={startupPackinfo}
                            to={SIGNUP_ROUTE}
                        />
                    </div>
                    

                    <div className="col-md d-flex justify-content-center">
                        <PricingCard
                            image={BusinessPricingImage}
                            title="Business Builder"
                            info="4 to 12 Users"
                            price="109"
                            bg="#3A7367"
                            points={businessPackInfo}
                            to={SIGNUP_ROUTE}
                        />
                    </div>

                    <div className="col-md d-flex justify-content-center">
                        <PricingCard
                            image={CorporatePricingImage}
                            title="Corporate"
                            info="12+ Users"
                            price="129"
                            bg="#004B5B"
                            points={corporatePackInfo}
                            to={SIGNUP_ROUTE}
                        />
                    </div> */}

                        <div className="col-md d-flex justify-content-center">
                            <PricingCard
                                image={StartupPricingImage}
                                title="Start Up"
                                info="1-3 Agents"
                                price="110"
                                bg="#60C3AD"
                                points={startupPackinfo}
                                to={SIGNUP_ROUTE}
                                handler={handlePlanSelection}
                                plan="STARTUP_PLAN_ID"
                            />
                        </div>

                        <div className="col-md d-flex justify-content-center">
                            <PricingCard
                                image={BusinessPricingImage}
                                title="Business Builder"
                                info="4-12 Agents"
                                price="149"
                                bg="#3A7367"
                                points={businessPackInfo}
                                to={SIGNUP_ROUTE}
                                handler={handlePlanSelection}
                                plan="BUSINESS_BUILDER_ID"
                            />
                        </div>

                        <div className="col-md d-flex justify-content-center">
                            <PricingCard
                                image={CorporatePricingImage}
                                title="Corporate"
                                info="12+ Agents"
                                price="189"
                                bg="#004B5B"
                                points={corporatePackInfo}
                                to={SIGNUP_ROUTE}
                                handler={handlePlanSelection}
                                plan="CORPORATE_PRICE_ID"
                            />
                        </div>

                </div>
                </div>
            </div>
        </section>
    );
};

export default PricingSection;
